export default __webpack_public_path__ + "static/media/Dhananithi Jewellery.d40abc83.jpg";